let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("7R5g7")).then(() => parcelRequire('6qWjs'));